import getDefaultState from './get-default-state';

export default {
  setSubscriptions(state, subscriptions) {
    state.subscriptions = subscriptions;
  },

  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};
